import { INode } from '../../../general/model';
import { createAction } from '@reduxjs/toolkit';
import { CHNode } from '../../../general/node';

export const modalOpened = createAction<{ node: CHNode }, 'creativeHub/renaming/MODAL_OPENED'>(
  'creativeHub/renaming/MODAL_OPENED',
);
export const modalOpenUiEvent = createAction<void, 'creativeHub/renaming/MODAL_OPEN_UI_EVENT'>(
  'creativeHub/renaming/MODAL_OPEN_UI_EVENT',
);
export const modalClosed = createAction<void, 'creativeHub/renaming/MODAL_CLOSED'>(
  'creativeHub/renaming/MODAL_CLOSED',
);
export const modalCloseUiEvent = createAction<void, 'creativeHub/renaming/MODAL_CLOSE_UI_EVENT'>(
  'creativeHub/renaming/MODAL_CLOSE_UI_EVENT',
);
export const nameChanged = createAction<{ name: string }, 'creativeHub/renaming/NAME_CHANGED'>(
  'creativeHub/renaming/NAME_CHANGED',
);
export const confirmed = createAction<void, 'creativeHub/renaming/CONFIRMED'>(
  'creativeHub/renaming/CONFIRMED',
);
export const setProgress = createAction<
  { inProgress: boolean },
  'creativeHub/renaming/SET_PROGRESS'
>('creativeHub/renaming/SET_PROGRESS');
export const nodeChanged = createAction<
  { oldNodeID: number; newNode: INode },
  'creativeHub/renaming/NODE_CHANGED'
>('creativeHub/renaming/NODE_CHANGED');
export const renameButtonClicked = createAction<void, 'creativeHub/renaming/RENAME_BUTTON_CLICKED'>(
  'creativeHub/renaming/RENAME_BUTTON_CLICKED',
);
